/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "Echoes is an experimental performance produced in the XR Studio in collaboration with cellist Dennis Park of the LSU School of Music, and Irina Kruchinina of the School of Communication. Using the XR Studio's LED wall as a monitor of the camera feed creates a hall of mirrors effect, slowing the temporal experience of the performance, and overlapping ripples of moments to diffuse the audience's perception.");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
